import './img-usuario-directive.css';

var centralApp = angular.module('app.components');

centralApp.directive('imgUsuario', imgUsuarioFunc);

imgUsuarioFunc.$inject = ['ConfigApp']

function imgUsuarioFunc(ConfigApp)
{
    var semImg = {};

    return {
        link: function($scope, $element, $attr)
        {
            var name = 'src',
                //foto = ConfigApp.LinkFoto,
                padrao = require('assets/img/perfil.png');

            $element.on('error', function(){
                semImg[$attr.imgUsuario] = true

                $element.prop(name, $attr['img-padrao'] || padrao);
            })

            $attr.$observe('imgUsuario', function(usuario)
            {
                //deixar sempre a foto padrão
                // if (semImg[$attr.imgUsuario]) {
                //     $attr.$set(name, $attr['img-padrao'] || padrao)

                //     return
                // }
                
                $attr.$set(name, $attr['img-padrao'] || padrao)
                // $attr.$set(name, foto( usuario ))
            })

        }
    }
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/img-usuario/index.js
// module id = 313
// module chunks = 1